import { FormattedMessage } from 'react-intl';

import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

import messages from './RevokedView.messages';
import styles from './RevokedView.module.css';
import { Icon } from '@iwoca/orion';
import { getCountry } from '@iwIntlProvider/CountryProvider';

const RevokedView = () => {
    return (
        <MainSectionWrapper className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <Icon
                        icon="exclamationTriangleFilled"
                        className={styles.titleIcon}
                    />
                </div>

                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>

                {getCountry() === 'DE' && (
                    <div className={styles.bodyText}>
                        <FormattedMessage
                            data-test-id="declined-body-text"
                            {...messages.description}
                            values={{
                                p: (chunks) => <p>{chunks}</p>,
                                phoneNumber: (
                                    <a
                                        href="tel:069 9432 3020"
                                        className={styles.phoneNumber}
                                    >
                                        <FormattedMessage
                                            tagName="strong"
                                            {...messages.phoneNumber}
                                        />
                                    </a>
                                )
                            }}
                        />
                    </div>
                )}
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default RevokedView;
